import { render } from "./NoShowCancelled.vue?vue&type=template&id=04ff9514&scoped=true&lang=pug"
import script from "./NoShowCancelled.vue?vue&type=script&lang=js"
export * from "./NoShowCancelled.vue?vue&type=script&lang=js"

import "./NoShowCancelled.vue?vue&type=style&index=0&id=04ff9514&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ff9514"]])

export default __exports__